module.exports = __webpack_public_path__ + "img/05.5cb3ab9b.jpg";